import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

// 线条点击区域扩展宽度
export const EVENT_EXPAND_STROKE_WIDTH = browser.isMobile ? 16 : 10;

// 旋转模式偏移
export const ROTATE_MODE_LEFT_TOP_OFFSET = 80;
export const ROTATE_MODE_RIGHT_BOTTOM_OFFSET = 160;

export const MOBILE_CANVAS_CONTAINER_ID = 'mobile_canvas_container_id';
